import type { Offre } from '../types/offres';

/**
 * Une offre de l'onglet Offres, mise en texte pour servir de fiche de poste (« Modifier mon CV »).
 *
 * SANS LES COORDONNÉES DU RECRUTEUR : la politique de confidentialité (§ 5) promet que les offres
 * partent chez Anthropic sans elles. Mêmes retraits que `offrePourIA` côté serveur
 * (supabase/functions/offres-dossier/offre.ts) : rubriques contact et agence, et toute adresse ou
 * tout numéro glissé dans le texte libre.
 */

const RUBRIQUES_RETIREES = new Set(['contact', 'agence']);
const RETIRE = '[coordonnée retirée]';
const EMAIL = /[\p{L}\p{N}._%+-]+@[\p{L}\p{N}.-]+\.[\p{L}]{2,}/gu;
// Numéros français : 10 chiffres commençant par 0, groupés ou non, ou en +33. Les nombres d'une
// offre (24 mois, 35 h, 1 100 €) n'en ont ni la longueur ni la forme.
const TELEPHONE = /(?:\+33\s?|0)[1-9](?:[\s.-]?\d{2}){4}/g;

const sansCoordonnees = (texte: string) => texte.replace(EMAIL, RETIRE).replace(TELEPHONE, RETIRE);

export function ficheDepuisOffre(offre: Offre): string {
  const lignes = [
    // Adzuna ne transmet que le début de l'annonce (500 caractères) : le texte le dit.
    offre.source === 'adzuna' ? 'Extrait de l’annonce : Adzuna ne transmet que son début, le reste est inconnu.' : '',
    `Intitulé : ${offre.titre}`,
    offre.entreprise.nom ? `Entreprise : ${offre.entreprise.nom}` : '',
    offre.entreprise.description ? `Présentation de l’entreprise : ${offre.entreprise.description}` : '',
    offre.lieu.libelle ? `Lieu : ${offre.lieu.libelle}` : '',
    offre.contrat.libelle ? `Contrat : ${offre.contrat.libelle}` : '',
    offre.description ? `Description :\n${offre.description}` : '',
    ...offre.details.filter((d) => !RUBRIQUES_RETIREES.has(d.cle)).map((d) => `${d.cle} : ${d.valeur}`),
  ];
  return sansCoordonnees(lignes.filter(Boolean).join('\n'));
}
